"use client";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";


const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const {t} = useTranslation()

  return (
    <div role="alert">
      <p>{t("global.Somethingwentwrong")}:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>{t("global.Tryagain")}</button>
    </div>
  );
};

export default ErrorFallback;
